export default "__VITE_ASSET__CJNIu9_X__"